import http from "../http";


const FlightsService = {

        GetJrJson : async (KFZ,STD,JLVT,archiveStat) =>
        {

            // console.log("service"+KFZ+STD+JLVT);
            const JRJsonData = await http.instance.get("/Flights/GetJRjson/",{
                params :
                    {
                        KFZ : KFZ,
                        STD : STD,
                        JLVT : JLVT,
                        ArchiveStat :archiveStat,
                    }
            })

            return JRJsonData.data;

        },

        GetFlightsService: async (searchDate) => {
            const flights = await http.instance.get("/Flights", {params: {date: searchDate}});
            return flights.data
        },
        GetAdvanceSearch: async (form) => {
            const searchFlights = await http.instance.post("/Flights/AdvancedSearch", form);
            return searchFlights.data;
        }

    }
;
export default FlightsService;
